import UI from '../0-ui';
import {RadioOption} from './RadioOption';
import {is_function} from '../../../Helpers/js/simple.functions';

export class RadioGroup {
    constructor(radioDomNodes, onChange) {
        this.onChange = onChange;
        this.radios = [];
        this.initializeRadioOptions(radioDomNodes);

        UI.onShowEvent(this.repairInvalidStates.bind(this));
        UI.onHideEvent(this.repairInvalidStates.bind(this));
    }

    initializeRadioOptions(radioDomNodes) {
        radioDomNodes.map(radio => {
            var radioOption = new RadioOption(radio, this);
            radioOption.addKeyListener(this.handleKeydown.bind(this));
            radioOption.addClickListener(this.handleClick.bind(this));

            this.radios.push(radioOption);
        });

        this.setDefaultTabIndex();
    }

    hasCheckedRadio() {
        return this.getCheckedRadio() ? true : false;
    }

    getCheckedRadio() {
        return this.radios.find(radio => radio.isChecked());
    }

    getVisibleRadios() {
        return this.radios.filter(radio => radio.isVisible());
    }

    handleKeydown(event, radio) {
        if (event.target == radio.textInput) {
            return;
        }

        switch (event.key) {
            case 'Down':
            case 'ArrowDown':
            case 'Right':
            case 'ArrowRight':
                this.checkNextRadio(radio);
                event.preventDefault();

                break;
            case 'Up':
            case 'ArrowUp':
            case 'Left':
            case 'ArrowLeft':
                this.checkPreviousRadio(radio);
                event.preventDefault();

                break;
            case ' ': 			//Spacebar
            case 'Spacebar': 	//for older Browsers
                this.toggleRadio(radio);
                event.preventDefault();

                break;
            default:
                break;
        }

        this.triggerOnChange();
    }

    checkNextRadio(currentRadio) {
        var visibleRadios = this.getVisibleRadios();

        var currentIndex = visibleRadios.indexOf(currentRadio);

        var nextIndex = currentIndex < visibleRadios.length - 1 ? currentIndex + 1 : 0;
        var nextRadio = visibleRadios[nextIndex];

        currentRadio?.setUnchecked();
        nextRadio.setChecked();
        nextRadio.focus();
    }

    checkPreviousRadio(currentRadio) {
        var visibleRadios = this.getVisibleRadios();

        var currentIndex = visibleRadios.indexOf(currentRadio);

        var nextIndex = currentIndex > 0 ? currentIndex - 1 : visibleRadios.length - 1;
        var nextRadio = visibleRadios[nextIndex];

        currentRadio?.setUnchecked();
        nextRadio.setChecked();
        nextRadio.focus();
    }

    toggleRadio(radio) {
        if (radio.isChecked()) {
            radio.setUnchecked();
            // since no option is checked now, we need at least one to be accessible. we choose the last clicked.
            radio.setAccessible(true);
        } else {
            radio.setChecked();
        }
    }

    handleClick(event, radioOption) {
        event.stopPropagation();
        this.radios.map(radio => {
            if (radio != radioOption) {
                radio.setUnchecked();
            }
        });

        const isEventFromInput = event.target == radioOption.textInput;
        const isSafari = isEventFromInput && event.toElement; // only safari sets toElement to an object (13.10.23)

        // we want to toggle if a checked option is clicked
        // we dont want to toggle if click event happened on the input field. then we want to set checkec
        // exception is VoiceOver - in Voice-over we want to toggle. reason:
        //    our html (nested input in label/role=radio) causes voice-over:
        //      - to send every event from this input
        //      - to make the input not accessable at all
        if (!radioOption.isAriaChecked() || (isEventFromInput && !isSafari)) {
            radioOption.setChecked();
        } else {
            radioOption.setUnchecked();
            // since no option is checked now, we need at least one to be accessible. we choose the last clicked.
            radioOption.setAccessible(true);
        }

        this.triggerOnChange();
    }

    triggerOnChange() {
        if (is_function(this.onChange)) {
            this.onChange();
        }
    }

    repairInvalidStates() {
        // invalid states occure if an option is checked and afterwards is hidden by conditional visibility
        // => then the checked option is not visible => we need to uncheck it and reset tab-indexes

        var checkedRadio = this.getCheckedRadio();
        if (checkedRadio && !checkedRadio.isVisible()) {
            checkedRadio.setUnchecked();
        }

        this.setDefaultTabIndex();
    }

    setDefaultTabIndex() {
        // if no option is checked, we need to make the first option accessible
        var visibleRadios = this.getVisibleRadios();

        if (!this.hasCheckedRadio() && visibleRadios.length > 0) {
            this.radios.map(radio => radio.setAccessible(false));
            visibleRadios[0].setAccessible(true);
        }
    }

}